class CollectionByTypesSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.cbt-grid');
    if (!this.slider) return;

    this.slides = this.slider.querySelectorAll('.cbt-card');
    this.currentIndex = 0;
    this.isMobile = window.innerWidth <= 768;

    if (this.isMobile && this.slides.length > 1) {
      this.init();
    }

    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      if (this.isMobile && !wasMobile && this.slides.length > 1) {
        this.init();
      } else if (!this.isMobile && wasMobile) {
        this.destroy();
      }
    });
  }

  init() {
    this.createDots();
    this.slider.scrollLeft = 0;
    this.currentIndex = 0;
    this.updateSlide();
    this.addSwipeListeners();
  }

  destroy() {
    const dotsContainer = this.querySelector('.cbt-dots');
    if (dotsContainer) dotsContainer.remove();
    this.slider.scrollLeft = 0;
  }

  createDots() {
    if (this.querySelector('.cbt-dots')) return;

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'cbt-dots';

    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'cbt-dot';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      if (index === 0) dot.classList.add('active');

      dot.addEventListener('click', () => {
        this.goToSlide(index);
      });

      dotsContainer.appendChild(dot);
    });

    this.appendChild(dotsContainer);
  }

  updateSlide() {
    if (!this.isMobile) return;

    const slideWidth = window.innerWidth;
    this.slider.scrollTo({ left: this.currentIndex * slideWidth, behavior: 'smooth' });

    const dots = this.querySelectorAll('.cbt-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlide();
  }

  addSwipeListeners() {
    let startX = 0;

    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX;
    });

    this.slider.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].pageX;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && this.currentIndex < this.slides.length - 1) {
          this.currentIndex++;
        } else if (diff < 0 && this.currentIndex > 0) {
          this.currentIndex--;
        }
        this.updateSlide();
      }
    });

    let scrollTimeout;
    this.slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const newIndex = Math.round(this.slider.scrollLeft / window.innerWidth);
        if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.slides.length) {
          this.currentIndex = newIndex;
          const dots = this.querySelectorAll('.cbt-dot');
          dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentIndex);
          });
        }
      }, 100);
    });
  }
}

customElements.define('cbt-slider', CollectionByTypesSlider);
